<nav>
    <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item pe-1">
            <span class="nav-link" *ngIf="isFemaleParentsComponent" jhiTranslate="design-crosses.female.parents" [routerLink]="['design-crosses-study-list']" [routerLinkActive]="['active']" queryParamsHandling="merge">
                Female Parents
            </span>
            <span class="nav-link" *ngIf="!isFemaleParentsComponent" jhiTranslate="design-crosses.male.parents" [routerLink]="['design-crosses-study-list']" [routerLinkActive]="['active']" queryParamsHandling="merge">
                Male Parents
            </span>
        </li>
    </ul>
    <!-- TODO router-outlet sticky state? router-outlet not possible right now because we don't want to reload tabs  -->
    <div class="tab-content">
        <div role="tabpanel" class="tab-pane container-fluid active">
            <div style="height: 400px;">
                <br/>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col d-flex align-items-center">
                            <img class="image-icon-sm"  src="content/images/list-types.png">
                            <h4 class="ms-1" style="padding-top: 5px;">
                                <span jhiTranslate="design-crosses.list.entries">List Entries</span>&nbsp;
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-10 d-flex align-items-center justify-content-start">
                        <span jhiTranslate="global.total.entries" [translateValues]="{param: totalItems}"></span>
                        @if (parents.length > 0) {
                            <jhi-selection-count [showSelectAll]="true"
                                                 [isSelectAll]="isSelectAll"
                                                 [totalItemsSize]="totalItems"
                                                 [selectedItemsSize]="selectedItems.size"
                                                 (deselectAction)="clearSelectedItems()"
                                                 (selectAllAction)="selectAll($event)"></jhi-selection-count>
                        }
                    </div>
                    <div class="col-2 d-flex align-items-center justify-content-end">
                        <div ngbDropdown class="d-inline-block ps-2" placement="bottom-right">
                            <button  class="btn btn-info btn-sm" id="columnsDropdown" ngbDropdownToggle>
                                <span translate="study-editor.actions"></span>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="columnsDropdown">
                                <button ngbDropdownItem type="submit"
                                        (click)="clearAll()">
                                    <span jhiTranslate="design-crosses.actions.clear.all"></span>
                                </button>
                                <button ngbDropdownItem type="submit"
                                        (click)="removeSelected()">
                                    <span jhiTranslate="design-crosses.actions.remove.selected"></span>
                                </button>
                                <button ngbDropdownItem type="submit"
                                        (click)="selectEvenEntries()">
                                    <span jhiTranslate="design-crosses.actions.select.even"></span>
                                </button>
                                <button ngbDropdownItem type="submit"
                                        (click)="selectOddEntries()">
                                    <span jhiTranslate="design-crosses.actions.select.odd"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div class="table-responsive custom-scroll-style" style="height: 260px; overflow: auto" [id]="isFemaleParentsComponent ? 'femaleParentsListDrop': 'maleParentsListDrop'"
                     cdkDropList (cdkDropListDropped)="drop($event)">
                    <table class="table table-striped table-bordered table-curved">
                        <thead class="sticky-header">
                        <tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="sort.bind(this)">
                            <th><input type="checkbox" class="form-check-input" [ngbTooltip]="'global.select.current.page' | translate" [checked]="isPageSelected()" (click)="onSelectPage()"></th>
                            <th [jhiSortBy]="ColumnHeaders.INDEX"><span>#</span> <span class="fa fa-sort"></span></th>
                            <th [jhiSortBy]="ColumnHeaders.DESIGNATION"><span jhiTranslate="design-crosses.source.list.desig">DESIGNATION</span> <span class="fa fa-sort"></span></th>
                            <th [jhiSortBy]="ColumnHeaders.CROSS"><span jhiTranslate="design-crosses.source.list.cross">CROSS</span> <span class="fa fa-sort"></span></th>
                        </tr>
                        </thead>
                        <tbody *ngIf="parents.length">
                        <tr *ngFor="let parent of parents; trackBy: trackId; index as index"
                            (click)="toggleSelect($event, index, parent); $event.stopPropagation()"
                            [class.selected]="isSelected(parent)"
                            (mousedown)="$event.preventDefault()"
                            cdkDrag
                            #p="ngbPopover"
                            (contextmenu)="showRightClickMenu($event, p)"
                            [autoClose]="true"
                            [triggers]="'manual'"
                            [ngbPopover]="parentListContextMenu">
                            <td><input type="checkbox" class="form-check-input" [checked]="isSelected(parent)" (click)="toggleSelect($event, index, parent, true); $event.stopPropagation()"></td>
                            <td>{{parent.index}}</td>
                            <td><a class="link" (click)="germplasmDetailsPopupService.open(parent.gid)"><truncate-span [textInput]="parent.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a></td>
                            <td><truncate-span [textInput]="parent.cross" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</nav>


<ng-template #parentListContextMenu>
    <div class="p-2">
        <button class="btn btn-sm btn-outline-info w-100 mt-2" (click)="removeSelected()" jhiTranslate="design-crosses.actions.remove.selected">
        </button>
        <button class="btn btn-sm btn-outline-info w-100 mt-2" (click)="clearAll()" jhiTranslate="design-crosses.actions.clear.all">
        </button>
    </div>
</ng-template>
